import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const notify = (msg: string) => toast(msg);
const notifySuccess = (msg: string) => toast.success(msg);
const notifyError = (msg: string) => toast.error(msg);
const notifyWarn = (msg: string) => toast.warn(msg);
const notifyInfo = (msg: string) => toast.info(msg);

const ToastBox = () => <ToastContainer />

export { notify, notifySuccess, notifyError, notifyWarn, notifyInfo, ToastBox };